<template>
  <div class="chart-container">
      <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        class="line-chart"
      />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default {
  name: 'BaseMinimapLineDiagram',
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    legendPosition: {
      type: String,
      default: 'right',
    },
    chartTitle: {
      type: String,
      default: '',
    },

    maxRangeY: {
      type: Number,
      default: 1000,
    },
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    chartOptions() {
      return {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: false,
            type: "linear",
            min: 0,
            max: this.maxRangeY,
            grid: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: false,
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        animation: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },        
        datasets: {
          line: {
            // Common settings for all lines
            borderWidth: 1,
            hoverBorderWidth: 1,
            pointHitRadius: 0,
            pointRadius: 0,
          },
        },
      }
    },
  },
  methods: {
     },
};
</script>

<style scoped>
.chart-container {
  height: 3.8rem;
  padding: 0rem;
}
.line-chart {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3.8rem;
}
</style>
